export const structure = {
  label: 'Group',
  title: 'Corporate Structure',
  subtitle: 'Overview of DR Group and its participations',
  holdco: {
    name: 'DR Group GmbH',
    type: 'Investment Holding'
  },
  participations: {
    s4chain: {
      name: 'S4Chain GmbH',
      status: 'Operational',
      description: 'Services provided by S4Chain only',
      link: 'Visit website'
    },
    placeholder: 'Further participations'
  },
  future: {
    title: 'Future PropCo',
    subtitle: 'Concept placeholder'
  }
};